import {
  ChartBarIcon,
  OfficeBuildingIcon,
  UsersIcon,
  GiftIcon,
  CogIcon,
  LogoutIcon,
} from "@heroicons/react/solid";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const links = [
  { to: "/admin", label: "Dashboard", icon: ChartBarIcon },
  { to: "/admin/consultancies", label: "Consultancies", icon: OfficeBuildingIcon },
  { to: "/admin/students", label: "Students", icon: UsersIcon },
  { to: "/admin/offers", label: "Offers", icon: GiftIcon },
  { to: "/admin/settings", label: "Settings", icon: CogIcon, disabled: true },
];

export default function AdminSidebar({ collapsed, onToggle }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  const linkClasses = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 rounded-2xl transition ${
      isActive
        ? "bg-gradient-to-r from-indigo-500/90 to-purple-500/90 text-white shadow-lg"
        : "text-white/70 hover:bg-white/10"
    } ${collapsed ? "justify-center" : ""}`;

  return (
    <aside
      className={`hidden bg-gradient-to-b from-slate-950 via-slate-900 to-blue-900 text-white border-r border-white/10 transition-all lg:flex ${
        collapsed ? "w-20" : "w-64"
      } flex-shrink-0`}
    >
      <div className="h-full flex flex-col">
        <div className="px-4 py-5 flex items-center justify-between border-b border-white/10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center font-bold shadow-lg">
              AJ
            </div>
            {!collapsed && (
              <div>
                <p className="text-sm uppercase tracking-[4px] text-white/70">AbroadJacks</p>
                <p className="text-lg font-semibold">Admin Panel</p>
              </div>
            )}
          </div>
          <button
            className="p-2 rounded-full bg-white/10 hover:bg-white/20"
            onClick={onToggle}
            aria-label="Toggle sidebar"
          >
            <svg
              className="h-4 w-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-2">
          {links.map((link) =>
            link.disabled ? (
              <div
                key={link.to}
                className={`flex items-center gap-3 px-4 py-3 rounded-2xl text-white/30 border border-white/5 ${
                  collapsed ? "justify-center" : ""
                }`}
              >
                <link.icon className="h-5 w-5" />
                {!collapsed && <span>{link.label}</span>}
              </div>
            ) : (
              <NavLink key={link.to} to={link.to} end={link.to === "/admin"} className={linkClasses}>
                <link.icon className="h-5 w-5" />
                {!collapsed && <span>{link.label}</span>}
              </NavLink>
            )
          )}
        </nav>

        <div className="p-4 border-t border-white/10">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 justify-center rounded-2xl bg-gradient-to-r from-rose-500 to-red-500 px-4 py-3 font-semibold shadow-lg"
          >
            <LogoutIcon className="h-5 w-5" />
            {!collapsed && <span>Logout</span>}
          </button>
        </div>
      </div>
    </aside>
  );
}
